import styled from 'styled-components';
import { media } from '../../../common/styles/styleUtil';

export const BreadcrumbWrapper = styled.div`
  ${media.xs`
    display: none;
  `}
  .breadcrumb {
    padding: 8px 24px;
    border-bottom: 1px solid #d2d6da;
    font-size: 11px;
    color: #697684;
    line-height: 13px;
    font-weight: 300;
    a {
      height: 13px;
    }
  }
`;
